/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![XboxNeutralIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAACcklEQVR4nMVVO2tUURBeUfGFCmJ8ga9KC8VaC7daWJM7jxs4O7PJQkzhgo1GsNBCEbUTf4CgaGNhbBRBRUFBwcJHCIKQNBEftQomoiiuzN1s7tm792bZVfDAac6Z883M983MyeX+5wqC8lpkOYqkd4H1LbLOAOk3YH0PLPcx1CNF53q6Ag/DyjogOQesD5H1O7LWEvsnsD4yGyLZ9leZOOdWR5mwTlkmwHoSUTd1DNTbP7AVSZ8DyZUgcFuS9/l8fpFzbmHyHEDXI+tlJB1HdDtSwfNDQ0uBZaxBAbB8DlgOtAsq4PJeZP049450slCorGgxjNJO8Aykv4B0JAscsTQMpD9a9ZHTTYbm0SJOEbKGJNcyHbBeSHsDpF+bqgtIDqYasrwOgmB5loNqtboYSZ5lvK369FxPMZoJ+ss7k6BJka1EgfRLSub3fAcTSYOA5LgPVCwOrkLSUWs6RFyZoOpQSoDvfIOZRHov/Eidc2uA5aV3PxaGgxs9HwuA9UmSAc+BTHsXv4lk31zkzvVE9d3Csb6xURJTNbDbqs4X2hNZJ2PudDRBy3hqddVtX1mXe0xcjR3IhzgDkhuNi76wtMerkAeZ4LGYT51zy6JAwW1vZAEst1vKFFgfe1ldbAse70txsHorOsPScGujoR6LwEMtmBYdOKghajhbkRUb6b4+DaFPIJb2W/WYgB2Bc7SnbJ71haVdQHKmCbwuaHEJkWy2AdcFeG2W4pJFPl/356zBunWArGdz7VavcxvsT+gi+gn7T9o6aNAFJKesWdqDyzSQnp+XlqxlTQQsh5H0js0WZPlU3/Z1yk379G2MdAz8L9cfihc9G7vCacsAAAAASUVORK5CYII=)
 */
export const XboxNeutralIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M10.9 22.95c-1.7-.16-3.4-.77-4.88-1.73-1.24-.8-1.52-1.13-1.52-1.8 0-1.32 1.46-3.65 3.96-6.3 1.42-1.5 3.4-3.26 3.61-3.22.42.1 3.74 3.33 4.98 4.86 1.97 2.4 2.87 4.38 2.41 5.26-.35.67-2.51 1.98-4.1 2.48-1.32.42-3.04.6-4.46.45Zm-8.06-4.9a11.4 11.4 0 0 1-1.8-5.37A8.59 8.59 0 0 1 1.23 10c.3-1.9 1.38-4.08 2.67-5.43.56-.57.6-.59 1.28-.36.81.27 1.69.88 3.04 2.1l.79.71-.43.53c-2 2.46-4.12 5.94-4.91 8.1-.43 1.17-.6 2.34-.42 2.83.12.34 0 .21-.41-.43Zm18.01.26c.1-.5-.03-1.4-.33-2.32-.65-1.98-2.82-5.67-4.82-8.18l-.63-.8.68-.62c.89-.81 1.5-1.3 2.17-1.71a4.18 4.18 0 0 1 1.6-.62c.2 0 .9.73 1.46 1.52a11.51 11.51 0 0 1 1.85 4.26c.21 1 .23 3.15.03 4.14-.16.82-.5 1.89-.82 2.6-.25.55-.86 1.6-1.13 1.94-.14.17-.14.17-.06-.2ZM11.08 3.68a13.7 13.7 0 0 0-3.12-1.1 5.74 5.74 0 0 0-1.05-.06c-.65.03-.62 0 .42-.5.87-.4 1.59-.64 2.57-.84 1.1-.24 3.17-.24 4.25-.01 1.17.25 2.55.76 3.33 1.24l.23.14-.53-.03c-1.06-.05-2.59.37-4.24 1.17-.5.25-.92.44-.96.43-.03 0-.43-.2-.9-.44Z"
        className={colorClass}
      />
    </svg>
  );
};
